import React from "react";
import { Logo } from "../../../assets/images/Images";

export default function LogoCard() {
  return <img src={Logo} alt="logo" className="w-30 h-10 object-contain" />;
}
